<template>
  <div class="center-warp">
    <div class="inner">
      <div class="d-flex-between">
        <div v-if="!showCaseDetail" class="box-search d-flex-between">
<!--          <input type="text" placeholder="病例名称、ID、医生姓名" v-model="queryParams.keyWords" @keydown.enter="getList('new')">-->
          <Input :placeholder="'病例名称、ID、医生姓名'" v-model="queryParams.keyWords" @enter="getList('new')"/>
          <div class="iconfont icon-sousuo"  @click="getList('new')"></div>
        </div>
        <div v-if="showCaseDetail" style="margin-left: 0" class="add-btn" @click="showCaseDetail = false">返回</div>
        <div class="case-header-right d-flex">
          <div class="case-header-btn">智贝云分析</div>
          <div class="case-header-btn" @click="showBriefDialog = true">查看对方资料</div>
        </div>
      </div>
      <div class="case-content">
        <div v-show="!showCaseDetail" class="case-doctor-list-warp" @scroll="handleScroll">
          <div class="case-doctor-list" :class="patient_id == item.id ? 'on' : ''" v-for="item in list" :key="item.id" @click="handleChange(item)">
            <img class="case-doctor-list-img" :src="item.head_pic" alt="">
            <div style="flex: 1">
              <div class="case-doctor-list-info d-flex-between">
                <div>{{item.name}}</div>
                <div>{{item.doctor_name ? (item.doctor_name + '医生') : ''}}</div>
              </div>
              <div class="black-14">{{item.no}}</div>
            </div>
            <img v-if="patient_id == item.id" class="case-copy" @click.stop="copyText(item)" src="@/assets/img/case_consult/copy.png" alt="">
          </div>
          <div v-if="loadStatus" class="load-info"><i v-if="loadStatus == 'load'" class="el-icon-loading"></i><span
            v-if="loadStatus == 'load'">加载中</span><span v-if="loadStatus == 'over'">已经全部加载完成</span></div>
        </div>
        <div v-if="showCaseDetail" class="d-flex" style="width: 436px">
          <Card :id="patient_id"  :caseDetailValue="showCaseDetailValue" @cardId="getCardId"/>
          <Detail :id="cardId" ref="detail"/>
        </div>
        <div style="width:520px;height: 100%" v-loading="loading">
          <Chat ref="chat" :caseId="patient_id" v-if="patient_id" @finish="loadFinish" />
        </div>


      </div>

      <el-dialog
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="showCaseCardDetail"
        custom-class="page-dialog"
        width="834px">
        <div class="case-card-detail">
          <div class="case-card-detail-right">
            <div class="case-card-detailtitle d-flex-between">
              <div>其他资料</div>
              <div class="add-btn case-card-btn" @click="showCaseCardDetail = false">返回</div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">CurUserIsInGroup</div>
              <div class="case-upload-line">
                <template v-if="otherCardData.other_media_json && otherCardData.other_media_json.media" >
                  <div v-for="item in otherCardData.other_media_json.media" class="upload-video-item">
                    <video controls :poster="item.fm_img" :src="item.url"></video>
                    <div>MP4</div>
                  </div>
                </template>
              </div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">补充文件资料</div>
              <div class="case-upload-line">
                <template v-if="otherCardData.other_media_json && otherCardData.other_media_json.file" >
                  <div v-for="item in otherCardData.other_media_json.file" class="upload-file-item" @click="openUrl(item.url)">
                    <div class="upload-file-item-icon">
                      <img alt="" src="../../assets/img/case_management/upload-file.png">
                    </div>
                    <div class="upload-file-item-name limit-2">{{ item.title }}</div>
                  </div>
                </template>
              </div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">智贝云分析报告</div>
<!--              <div class="case-upload-line">-->
<!--                <div v-for="i in 2" class="upload-file-item">-->
<!--                  <div class="upload-file-item-icon">-->
<!--                    <img alt="" src="../../assets/img/case_management/upload-report.png">-->
<!--                  </div>-->
<!--                  <div class="upload-file-item-name limit-1">侧位片分析</div>-->
<!--                  <div class="upload-file-item-time">2023.09.26</div>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </el-dialog>
<!--      对方资料-->
      <el-dialog
        :show-close="false"
        :visible.sync="showBriefDialog"
        custom-class="page-dialog"
        top="20vh"
        width="328px">
        <div class="brief-card" v-if="showCaseDetailValue.id">
          <img :src="member.member_type == 0 ? briefImg.mentorBg : briefImg.bg "
               alt=""
               class="brief-card-bg">
          <template v-if="member.member_type == 0">
            <div class="brief-info">
              <img :src="showCaseDetailValue.mentor.head_pic" alt="">
              <div class="brief-info-name">
                <div>{{ showCaseDetailValue.mentor.real_name }}</div>
                <div>{{
                    showCaseDetailValue.mentor.city
                  }}·{{ showCaseDetailValue.mentor.province }}/{{ showCaseDetailValue.mentor.organization }}
                </div>
              </div>
            </div>
            <div class="brief-person-des">
              <img alt="" src="../../assets/img/case_management/brief-icon.png">
              <div>{{ showCaseDetailValue.mentor.introduction }}</div>
            </div>
          </template>
          <template v-else>
            <div class="brief-info">
              <img :src="showCaseDetailValue.doctor.head_pic" alt="">
              <div class="brief-info-name">
                <div>{{ showCaseDetailValue.doctor.real_name }}</div>
                <div>{{
                    showCaseDetailValue.doctor.city
                  }}·{{ showCaseDetailValue.doctor.province }}/{{ showCaseDetailValue.doctor.organization }}
                </div>
              </div>
            </div>
            <div class="brief-person-des">
              <img alt="" src="../../assets/img/case_management/brief-icon.png">
              <div>{{ showCaseDetailValue.doctor.introduction }}</div>
            </div>
          </template>
          <div class="brief-btn black-14" @click="showBriefDialog = false">确定</div>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import { getMyParticipatedCases } from "@/http/case_consult";
import Chat from "@/views/case_management/case_components/Chat";
import Card from "@/views/case_management/case_components/Card";
import Detail from "@/views/case_management/case_components/Detail";
import {GetCaseInfo, GetOtherInfo} from "@/http/api";
export default {
  name: "index",
  components: { Chat,Card,Detail },
  data() {
    return {
      member: JSON.parse(localStorage.getItem('member')),
      list: [],
      total: 0,
      last_page: 0,
      patient_id: undefined,
      queryParams: {
        page: 1,
        pageSize: 20,
        keyWords:''
      },
      loadStatus:'',
      showCaseDetail:false,//显示病例详情
      showCaseDetailValue:{}, //显示病例详情内容
      cardId:'',
      otherCardData:{},
      showCaseCardDetail:false, //显示其它资料
      showBriefDialog:false,
      briefImg:{
        bg:require('@/assets/img/case_management/brief-bg.png'),
        mentorBg:require('@/assets/img/case_management/brief-bg-mentor.png')
      },
      loading:true
    };
  },
  mounted() {
    this.getList('new');
  },
  methods: {
    getCardId(id) {
      let _that = this
      console.log(id)
      this.$nextTick(() => {
        _that.cardId = Number(id)
        _that.$refs.detail.init(Number(id))
      })
    },
    getList(type) {
      if(type == 'new'){
        this.queryParams.page = 1
        this.list = []
      }
      this.$store.commit('workStart')
      this.loadStatus = 'load'
      getMyParticipatedCases(this.queryParams).then((res) => {
        this.loadStatus = ''
        this.list = this.list.concat(res.data.data);
        this.total = res.data.total
        this.last_page = res.data.last_page
        if (!this.patient_id) this.handleChange(res.data.data[0])
        this.$store.commit('workOver')
      });
    },
    handleChange(row) {
      this.patient_id = false;
      this.loading = true
      this.$nextTick(() => {
        this.patient_id = row.id;
        GetCaseInfo({id:row.id}).then(res=> this.showCaseDetailValue = res.data)
      });
    },
    loadFinish(){
      this.loading = false
    },
    //监听列表滚动触底刷新
    handleScroll(e) {
      var scrollTop = e.target.scrollTop;
      var windowHeight = e.target.clientHeight;
      var scrollHeight = e.target.scrollHeight;
      if (scrollTop + windowHeight >= scrollHeight - 20) {
        // 当前滚动条已经触底
        if (this.$store.state.workState) this.getNextPage();
      }
    },
    getNextPage() {
      if (this.queryParams.page >= this.last_page) {
        this.loadStatus = 'over'
        return;
      }
      this.queryParams.page++;
      this.getList()
    },
    copyText(item){
      this.showCaseDetail = true
      // this.$copyText(info).then(()=>{
      //   this.$message({
      //     type:'success',
      //     message:'复制成功'
      //   })
      // }).catch(()=>{
      //   this.$message({
      //     type:'success',
      //     message:'复制失败'
      //   })
      // })
    },
    openOtherData(){
      this.initCardOtherData()
      this.showCaseCardDetail = true
    },
    initCardOtherData(){
      GetOtherInfo({card_id:this.cardId}).then(res=>{
        this.otherCardData = res.data
      })
    },
  },
};
</script>

<style scoped src="../../assets/css/case_consult.css">
</style>>

<style scoped src="../../assets/css/case.css">
</style>

<style scoped src="../../assets/css/chat.css">
</style>
<style>
.history-date-btn {
  position: relative;
  overflow: hidden;
}

.history-date-btn .icon-rili {
  cursor: pointer;
  padding-left: 15px;
  color: #333333;
  font-size: 20px;
  background: #F4F4F4;
  pointer-events: none;
  position: relative;
  z-index: 2;
}

.history-date-table {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  cursor: pointer;
}
.chat-in-msg textarea{
  resize: none;
  border: none;
  outline: none;
  padding: 0;
}
.page-dialog, .page-dialog .el-dialog__header, .page-dialog .el-dialog__body {
  padding: 0;
  background: transparent;
  box-shadow: none;
}
</style>
